import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  DASHBOARD_SPA_APPOINTMENTS_VIEW,
  DASHBOARD_SPA_VIEW,
} from '../../../constants/DashboardConst';
import {
  RBAC_PERMISSION_LEVEL_NO_ACCESS,
  RBAC_TYPE_DASHBOARD_SPA,
} from '../../../constants/RoleConsts';
import { selectedHotelSelector, fetchAllSpa } from '../../property/propertySlice';
import {
  dashboardSpaListSelector,
  dashboardViewStateSelector,
  setDashboardViewState,
  fetchSpaDashboardOrderList,
} from '../DashboardSlice';
import DashboardSpaAppointmentView from './dashboard-spa-appointment-view/DashboardSpaAppointmentView';
import DashboardSpaList from './dashboard-spa-list/DashboardSpaList';
import DashboardSpaView from './dashboard-spa-view/DashboardSpaView';
import { decryptLocalStorage } from '../../../utils/authUtils';

const DashboardSpa = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const selectedHotel = useSelector(selectedHotelSelector);
  const dashboardViewState = useSelector(dashboardViewStateSelector);
  const allDashboardSpaList = useSelector(dashboardSpaListSelector);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const currentFilterFromLocation = location?.state?.status;

  useEffect(() => {
    let isSelectedHotel = selectedHotel || decryptLocalStorage('hotelId');
    if (!isSelectedHotel) {
      history.push('/properties');
    }
  }, [history, selectedHotel]);

  useEffect(() => {
    if (
      selectedHotel &&
      permissions &&
      permissions[RBAC_TYPE_DASHBOARD_SPA] !== RBAC_PERMISSION_LEVEL_NO_ACCESS
    ) {
      dispatch(fetchSpaDashboardOrderList(selectedHotel));
      dispatch(fetchAllSpa(selectedHotel));
    }
  }, [selectedHotel, permissions, dispatch]);

  const onViewToggle = (type, status, obj) => {
    dispatch(setDashboardViewState({ type: type, status: status, obj: obj }));
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case DASHBOARD_SPA_VIEW:
        return (
          <DashboardSpaView
            obj={dashboardViewState.obj}
            onViewToggle={onViewToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case DASHBOARD_SPA_APPOINTMENTS_VIEW:
        return (
          <DashboardSpaAppointmentView
            onViewToggle={onViewToggle}
            hotelId={selectedHotel}
            allDashboardSpaList={allDashboardSpaList}
            obj={dashboardViewState.obj}
            showLoader={showLoader}
          />
        );
      default:
        break;
    }
  };

  return (
    <>
      {dashboardViewState.status && <>{switchViewContent(dashboardViewState)}</>}
      {!dashboardViewState.status && (
        <>
          <DashboardSpaList
            onViewToggle={onViewToggle}
            hotelId={selectedHotel}
            permissions={permissions}
            allDashboardSpaList={allDashboardSpaList}
            onsetPage={(e) => setPage(e)}
            page={page}
            onsetRowsPerPage={(e) => setRowsPerPage(e)}
            rowsPerPage={rowsPerPage}
            currentFilterFromLocation={currentFilterFromLocation}
          />
        </>
      )}
    </>
  );
};

export default DashboardSpa;
